"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const api_1 = require("./lib/api");
const providerList_1 = tslib_1.__importDefault(require("./providerList"));
const scrileConnect_1 = tslib_1.__importDefault(require("./projects/scrileConnect"));
tslib_1.__exportStar(require("./types"), exports);
let prevProviderClasses = undefined;
class ApiTools {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    close() {
        this.apiClient.close();
    }
}
function providersFactory(opt, providers) {
    if (prevProviderClasses) {
        // TODO since we cache fragments globally, we can't use multiple project providers yet to avoid fragment mixing.
        if (prevProviderClasses !== providers)
            throw new Error("Can't create more than one set of providers.");
    }
    else {
        prevProviderClasses = providers;
    }
    const api = api_1.apiFactory(opt);
    let res = {};
    for (const key in providers) {
        const provider = providers[key];
        res[key] = new provider(api, opt.notificationCB);
    }
    return { providers: res, apiTools: new ApiTools(api) };
}
function inMemoryStorageFactory() {
    const data = {};
    return {
        getString: function (key, defaultValue) {
            var _a;
            return _a = data[key], (_a !== null && _a !== void 0 ? _a : defaultValue);
        },
        setString: function (key, value) {
            data[key] = value;
        },
    };
}
exports.inMemoryStorageFactory = inMemoryStorageFactory;
function core(opt) {
    return providersFactory(opt, providerList_1.default);
}
exports.core = core;
function scrileConnect(opt) {
    return providersFactory(opt, scrileConnect_1.default);
}
exports.scrileConnect = scrileConnect;
exports.default = core;
//# sourceMappingURL=index.js.map